/*
 * Handing the paved drive to Waze or Google Maps.
 *
 * They drive better on roads than anything here, and know the traffic -- but
 * not 4x4 tracks. So the point they are given is where the paved part of the
 * route ends:
 *
 *   4x2 + walk   the drop-off, where the car is left
 *   4x4 + walk   the end of what a 4x2 could drive; the 4x4 part continues
 *                in PITRIOT from there
 *   walk         nothing: no drive to hand over
 *
 * ONLY that point leaves the app. The target itself -- often the place of a
 * specimen, sometimes of a rare one -- is never put in a link.
 */
export function externalDestination(route) {
  if (!route || !route.drive) return null;
  const point = route.mode === 'car4' ? route.endOfPaved || route.dropOff : route.dropOff;
  return point && Number.isFinite(point.lat) && Number.isFinite(point.lng) ? point : null;
}

const fixed = (n) => Number(n).toFixed(6);

export const wazeUrl = ({ lat, lng }) => `https://waze.com/ul?ll=${fixed(lat)},${fixed(lng)}&navigate=yes`;

export const googleMapsUrl = ({ lat, lng }) =>
  `https://www.google.com/maps/dir/?api=1&destination=${fixed(lat)},${fixed(lng)}&travelmode=driving`;
